import '../assets/css/LoadingSpinner.scss';

const LoadingSpinner = () => (
  <div className="hods-loading-spinner">
    <div
      className="hods-loading-spinner__spinner"
      aria-live="polite"
      role="status"
    />
    <div className="govuk-visually-hidden">
      Loading
    </div>
  </div>
);

export default LoadingSpinner;
